export default "__VITE_ASSET__AcQVaaEQ__"